import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@material-ui/core/TextField';
import useStyles from './styles';

function Input({...rest}) {

  const classes = useStyles();

  return (
    <TextField
      id='_id'
      label='Identificador'
      placeholder='Identificador'
      autoComplete='off'
      className={classes.formControl}
      InputLabelProps={{
        shrink: true
      }}
      {...rest}
    />
  );
}

Input.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool
};

export default Input;
